import React from 'react';
import { TextField, NumberField, useRecordContext } from 'react-admin';
import { Chip } from '@mui/material';

import Datagrid from '../common/Datagrid';
import DateField from '../common/fields/DateField';
import ResourceLinkField from '../common/fields/ResourceLinkField';
import RecordSplitButton from '../common/buttons/RecordSplitButton';

const BillingFrequencyField = () => {
    const record = useRecordContext();
    if (!record) return null;

    const billingType = record.billing_frequency || 'oneshot';
    const label = billingType === 'monthly' ? 'Monthly' : 'One-shot';
    const color = billingType === 'monthly' ? 'primary' : 'default';

    return <Chip label={label} size="small" color={color} variant="outlined" />;
};

const InvoicedField = () => {
    const record = useRecordContext();
    if (!record) return null;

    return record.invoiced ? (
        <Chip label="Invoiced" size="small" color="success" variant="filled" />
    ) : (
        <Chip label="Not Invoiced" size="small" color="warning" variant="outlined" />
    );
};


const BudgetRow = ({ children, ...props }) => (
    <Datagrid {...props}>
        <ResourceLinkField label="Label" sortBy="label" resource="budgets">
            <TextField source="label" />
        </ResourceLinkField>
        <ResourceLinkField label="Customer" source="customer" resource="customers" sortBy="customer_id">
            <TextField source="name" />
        </ResourceLinkField>
        <ResourceLinkField label="Project" source="project" resource="projects" sortBy="project_id">
            <TextField source="name" />
        </ResourceLinkField>
        <TextField source="alias" />
        <NumberField source="amount" label="Amount" />
        <BillingFrequencyField label="Frequency" />
        <InvoicedField label="Status" />
        <DateField source="updated_at" />
        <RecordSplitButton />
        {children}
    </Datagrid>
);

export default BudgetRow;